module.exports = __webpack_public_path__ + "img/pmb4.a4b2e6b7.jpg";